/**
 * UI permission-keys for the `ENTITY` route (Entities screen).
 * Typed mirror of the BE CSV — confirm strings with the BE. (ENT-89 T15.)
 */
export const EntityAclKeys = {
  /** Access to the /entities listing + detail subtree. */
  listingRead: 'entities:listing:read',
  /** Add Entity — gates BOTH the launcher button and the /entities/new route. */
  onboard: 'entities:onboard',
  /**
   * Write gate for entity sub-resources (committees, appointments, etc.).
   * Mirrors BE ModuleAclGuard `module=entity-setup, action=write`.
   * Must match the BE CSV key exactly.
   */
  entitySetupWrite: 'entity-setup:write',
} as const;

export type EntityAclKey = (typeof EntityAclKeys)[keyof typeof EntityAclKeys];
